let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("anCeK")).then(() => parcelRequire('hK0IW'));